import { addExplored } from '../explored';
import type { SimContext, SimState, SystemFn } from '../types';
import { computeVision } from '../vision';

/**
 * Adds every tile each player can currently see to what they've explored;
 * attackers revealed through fog (`revealedTiles`) don't count.
 */
function recordExploration(state: SimState, ctx: SimContext): void {
  for (const [playerId, player] of Object.entries(state.players)) {
    if (player.eliminated) continue;
    const vision = computeVision(state, ctx.rules, playerId, { reveals: false });
    state.explored[playerId] = addExplored(ctx.terrain, state.explored[playerId], vision);
  }
}

const exploration: SystemFn = (state, ctx) => {
  recordExploration(state, ctx);
};

export { exploration, recordExploration };
